<template>
  <div class="bm-sign-up-detailed" >
    <div class="title" >审核球队</div>
    <p>点击通过即成为参赛球队，如需编辑球员信息请前往参赛球队设置</p>
    <div class="team" >
      <div>
        <img :src="formatterImgSrc(team.badge)">
      </div>
      <div>
        <p>{{ team.name }}</p>
        <span>{{ team.location }}</span>
      </div>
    </div>
    <!--
    <div class="team player" >
      <div>
        <img :src="formatterImgSrc(createUser.avatar)">
      </div>
      <div>
        <p> {{ createUser.nickName }} </p>
        <span> 申请人 </span>
      </div>
    </div>
    -->
    <div class="applicant" >
      <van-row>
        <van-col span="12">申请人</van-col>
        <van-col span="12" style="text-align: right" > {{ createUser.nickName }} </van-col>
      </van-row>
      <van-row>
        <van-col span="12">联系电话</van-col>
        <van-col span="12" style="text-align: right;" >
          <a :href="'tel://' + createUser.mobile " style="font-size: 16px; color:rgba(50,163,119,1);" > {{ createUser.mobile }} </a>
        </van-col>
      </van-row>
    </div>
    <div class="foot" >
      <van-row v-if="auditStatus === 1 || auditStatus === 0" >
        <van-col span="12">
          <div class="btn" @click="setTeamStatus(-1)" >拒绝</div>
        </van-col>
        <van-col span="12">
          <div class="btn active" @click="setTeamStatus(2)" >通过</div>
        </van-col>
      </van-row>
      <div class="btn" v-if="auditStatus === -1"  @click="isShowReview=true">已拒绝-重新审核</div>
    </div>
    <!-- 重新审核 start-->
    <van-popup v-model="isShowReview" position="bottom">
      <div class="popup-box">
        <div class="box-item success" @click="setTeamStatus(2)">通过</div>
        <div class="box-item" @click="isShowReview=false">取消</div>
      </div>
    </van-popup>
    <!-- end -->
  </div>
</template>
<script>
import vue from 'vue'
import { getBMPlayerList, updateBMMatchTeamAuditStatus } from '@/api/team'
import { ImageFormat } from '@/utils/'
import { Toast, Popup, Cell, CellGroup, Row, Col, Field } from 'vant'

vue.use(Toast).use(Popup).use(Cell).use(CellGroup).use({Row, Col, Field})

export default {
  name: 'BmSignUpDetailed',
  data() {
    return {
      query: this.$route.query,
      team: {},
      isShowReview: false,
      createUser: {},
      value: 15123641983
    }
  },
  created() {
    this.teamId = this.query.teamId
    this.matchId = this.query.matchId
    this.createUser = JSON.parse(this.query.createUser)
    this.auditStatus = Number(this.query.auditStatus)
    this.getBMPlayerList()
  },
  computed: {
    formatterImgSrc() {
      return function(src) {
        return ImageFormat.imageView(src, 104, 104)
      }
    }
  },
  methods: {
    getBMPlayerList() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId
      }
      getBMPlayerList(params).then(response => {
        let data = response.data
        this.team = data.team
      })
    },
    setTeamStatus(status) {
      let params = {
        matchId: this.matchId,
        teamId: this.teamId,
        auditStatus: status
      }
      let innerHtml = status === 2 ? '已通过' : '已拒绝'
      updateBMMatchTeamAuditStatus(params).then(response => {
        if (response) {
          Toast(innerHtml)
          this.$router.push({
            path: '/sign-up/list',
            query: {
              matchId: this.matchId
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" >
.bm-sign-up-detailed
  background-color: white
  width 100%
  height: 100%
  position absolute
  .title
    font-size: 30px;
    font-weight: 400;
    color: rgba(0,0,0,1);
    padding: 10px 15px;
  .title+p
    font-size:16px;
    font-weight:300;
    color:rgba(0,0,0,1);
    padding: 0 15px
    margin-top 0
  .team
    display flex
    padding 15px
    div:first-child
      width 52px
      height 52px
      margin-right: 10px
      img
        width 52px
        height 52px
    div:last-child
      display flex
      flex-direction column
      justify-content: space-between;
      width: calc(100% - 62px)
      p
        margin: 0;
        font-size:14px;
        font-weight:400;
        color:rgba(0,0,0,1);
      span
        font-size: 12px;
        font-weight: 400;
        color: #818181;
  .player
    div:first-child
      border-radius 50px
  .foot
    color: #32A377
    font-size 20px
    text-align center
    position fixed
    bottom: 0
    width: 100%
    padding: 0 !important
    .btn
      height: 50px
      line-height 50px
      width: 100%
      background:rgba(250,250,250,1);
      color: #EC4E4E
      font-size 18px
      font-weight:400;
    .active
      background:rgba(50,163,119,1);
      color: white
  .popup-box
    padding: 15px 20px;
    .box-item
      font-size: 16px;
      padding: 10px;
      text-align: center;
    .success
      color: #32A377;
      border-bottom: 1px solid #e6e6e6
  .player
    img
      border-radius 50px
  .applicant
    padding: 0 15px 15px;
    .van-row
      height: 54px;
      line-height 54px;
      font-size:16px;
      font-weight:300;
      color:rgba(74,74,74,1);
      border-bottom: 1px solid #E6E6E6

</style>



// WEBPACK FOOTER //
// src/pages/team/sign-up/detailed.vue